export function aggregateAnnualData(monthlyData) {
  // Group monthly data into years
  const yearlyData = monthlyData.reduce((acc, curr) => {
    const year = new Date(curr[0]).getFullYear();
    if (!acc[year]) {
      acc[year] = [];
    }
    acc[year].push(curr);
    return acc;
  }, {});

  // Aggregate the bots data within each year
  return Object.values(yearlyData).map(data => {
    const year = new Date(data[0][0]).getFullYear();
    const aggregated = [
      new Date(year, 0, 1).getTime(),  // start of the year
      0, // placeholder for bots data
    ];

    // Sum up the bots data
    aggregated[1] = data.reduce((acc, curr) => acc + curr[1], 0);

    return aggregated;
  });
}

export function aggregateAnnualDataForBar(data, timestamps) {
  const yearlyData = data.reduce((acc, currData, dataIndex) => {
    currData.forEach((val, index) => {
      const year = new Date(timestamps[index]).getFullYear();
      if (!acc[year]) {
        acc[year] = Array(data.length).fill(0);
      }
      acc[year][dataIndex] += val;
    });
    return acc;
  }, {});

  const years = Object.keys(yearlyData).sort();

  return {
    data: data.map((_, i) => years.map(year => yearlyData[year][i])),
    timestamps: years.map(year => new Date(year, 0, 1)),
  };
}
